<template>
  <article class="shop-type-block page-common">
    <CheckBannerTitle text1="美業店家必備" text2="預約、行銷、分潤" />

    <!-- <div class="banner-title">
      <img class="check-icon" src="@/assets/aboutUs/check-icon.svg" alt="" />
      <h4 class="mobile-mode">
        美容業商家必備<br />
        即時預約管理系統
      </h4>
    </div> -->

    <h3 class="sub-solgan">
      專為<span class="text-secondary-100">美業</span>打造的預約系統
    </h3>
    <!-- <div
      class="px-[16px] mt-[30px] flex flex-nowrap gap-[50px] overflow-x-auto desktop:(justify-center )"
    >
      <div v-for="item in items" :key="item.text">
        <div class="item">
          <div
            class="w-[120px] h-[120px] bg-white flex justify-center items-center rounded-full tablet:(h-[160px] w-[160px])"
          >
            <img :src="item.img" :alt="item.alt" />
          </div>
          <p class="item-text">{{ item.text }}</p>
        </div>
      </div>
    </div> -->

    <div class="mt-30px">
      <carousel
        class="laptop:hidden"
        :items-to-show="1"
        :mouse-drag="true"
        :touch-drag="true"
        :autoplay="0"
        :transition="500"
        snap-align="start"
      >
        <slide
          v-for="(chunk, index) in itemsChunkMobile"
          :key="index"
          class="flex flex-col gap-16px"
        >
          <div
            v-for="(row, rowIdx) in chunk"
            :key="rowIdx"
            class="w-480px flex justify-center gap-27.74px"
          >
            <div class="item pb-5px" v-for="item in row" :key="item.text">
              <div
                class="relative w-92px h-92px bg-white flex justify-center items-center rounded-full ipad:(h-92px w-92px) tablet:(h-91.6px w-91.6px)"
              >
                <img class="absolute w-full" :src="item.img" :alt="item.alt" />
              </div>
              <p class="text-[13.79px] font-medium mt-[15px]">
                {{ item.text }}
              </p>
            </div>
          </div>
        </slide>

        <template #addons>
          <Pagination />
        </template>
      </carousel>

      <carousel
        class="<laptop:hidden"
        :items-to-show="1"
        :wrap-around="true"
        :mouse-drag="true"
        :touch-drag="true"
        snap-align="start"
      >
        <slide v-for="(chunk, index) in itemsChunk" :key="index">
          <div class="flex gap-32px">
            <div class="item" v-for="item in chunk" :key="item.text">
              <div
                class="w-[92px] h-[92px] bg-white flex justify-center items-center rounded-full laptop:(h-[120px] w-[120px]) desktop:(h-[120px] w-[120px])"
              >
                <img :src="item.img" :alt="item.alt" class="w-full" />
              </div>
              <p class="item-text">{{ item.text }}</p>
            </div>
          </div>
        </slide>

        <template #addons>
          <Navigation />
          <Pagination />
        </template>
      </carousel>
    </div>

    <h3 class="solgan">
      運用美業預約系統，<br class="laptop:hidden" />吸客、留客、管店一次搞定！
    </h3>
  </article>
</template>

<script setup>
import { ref, computed } from '@vue/reactivity'
import { Carousel, Navigation, Pagination, Slide } from 'vue3-carousel'
import 'vue3-carousel/dist/carousel.css'
import { useWindowSize } from '@vueuse/core'
import CheckBannerTitle from '@/components/RheckBannerTItle.vue'

import icon1 from '@/assets/aboutUs/icon/2025/icon_1.webp'
import icon2 from '@/assets/aboutUs/icon/2025/icon_2.webp'
import icon3 from '@/assets/aboutUs/icon/2025/icon_3.webp'
import icon4 from '@/assets/aboutUs/icon/2025/icon_4.webp'
import icon5 from '@/assets/aboutUs/icon/2025/icon_5.webp'
import icon6 from '@/assets/aboutUs/icon/2025/icon_6.webp'
import icon7 from '@/assets/aboutUs/icon/2025/icon_7.webp'
import icon8 from '@/assets/aboutUs/icon/2025/icon_8.webp'
import icon9 from '@/assets/aboutUs/icon/2025/icon_9.webp'
import icon10 from '@/assets/aboutUs/icon/2025/icon_10.webp'
import icon11 from '@/assets/aboutUs/icon/2025/icon_11.webp'
import icon12 from '@/assets/aboutUs/icon/2025/icon_12.webp'
import icon13 from '@/assets/aboutUs/icon/2025/icon_13.webp'
import icon14 from '@/assets/aboutUs/icon/2025/icon_14.webp'

const { width, height } = useWindowSize()
const perView = computed(() => {
  if (width.value < 450) return 2.5
  else if (width.value < 650) return 2.5
  else if (width.value < 750) return 3.5
  else if (width.value < 980) return 3.5
  return 5
})

const itemsChunk = [
  [
    {
      img: icon1,
      text: '美甲業',
      alt: '美甲業預約系統',
    },
    {
      img: icon2,
      text: '美睫業',
      alt: '美睫業預約系統',
    },
    {
      img: icon3,
      text: '美容業',
      alt: '美容業預約系統',
    },
    {
      img: icon4,
      text: 'Spa 按摩',
      alt: 'Spa 按摩預約系統',
    },
    {
      img: icon5,
      text: '美髮沙龍',
      alt: '美髮沙龍預約系統',
    },
    {
      img: icon6,
      text: '美學牙科',
      alt: '美學牙科預約系統',
    },
    {
      img: icon7,
      text: '醫美診所',
      alt: '醫美診所預約系統',
    },
  ],
  [
    {
      img: icon8,
      text: '心靈療癒',
      alt: '心靈療癒預約系統',
    },
    {
      img: icon9,
      text: '體態雕塑',
      alt: '體態雕塑預約系統',
    },
    {
      img: icon10,
      text: '瑜珈美學',
      alt: '瑜珈美學預約系統',
    },
    {
      img: icon11,
      text: '紋繡霧眉',
      alt: '紋繡霧眉預約系統',
    },
    {
      img: icon12,
      text: '彩妝服務業',
      alt: '彩妝服務業預約系統',
    },
    {
      img: icon13,
      text: '美胸業',
      alt: '美胸業預約系統',
    },
    {
      img: icon14,
      text: '除毛業',
      alt: '除毛業預約系統',
    },
  ],
]

const itemsChunkMobile = [
  [
    [
      {
        img: icon1,
        text: '美甲業',
        alt: '美甲業預約系統',
      },
      {
        img: icon2,
        text: '美睫業',
        alt: '美睫業預約系統',
      },
      {
        img: icon3,
        text: '美容業',
        alt: '美容業預約系統',
      },
    ],
    [
      {
        img: icon4,
        text: 'Spa 按摩',
        alt: 'Spa 按摩預約系統',
      },
      {
        img: icon5,
        text: '美髮沙龍',
        alt: '美髮沙龍預約系統',
      },
    ],
  ],
  [
    [
      {
        img: icon6,
        text: '美學牙科',
        alt: '美學牙科預約系統',
      },
      {
        img: icon7,
        text: '醫美診所',
        alt: '醫美診所預約系統',
      },
      {
        img: icon8,
        text: '心靈療癒',
        alt: '心靈療癒預約系統',
      },
    ],
    [
      {
        img: icon9,
        text: '體態雕塑',
        alt: '體態雕塑預約系統',
      },
      {
        img: icon10,
        text: '瑜珈美學',
        alt: '瑜珈美學預約系統',
      },
    ],
  ],
  [
    [
      {
        img: icon11,
        text: '紋繡霧眉',
        alt: '紋繡霧眉預約系統',
      },
      {
        img: icon12,
        text: '彩妝服務業',
        alt: '彩妝服務業預約系統',
      },
    ],
    [
      {
        img: icon13,
        text: '美胸業',
        alt: '美胸業預約系統',
      },
      {
        img: icon14,
        text: '除毛業',
        alt: '除毛業預約系統',
      },
    ],
  ],
]
</script>

<style scoped lang="postcss">
.banner-title {
  @apply relative bg-primary-100 text-white rounded-br-[20px] w-[fit-content] m-auto py-[9px] px-[50px];
}

.check-icon {
  @apply absolute left-[-27px] top-[-12px] h-[54px];
}

.item-text {
  @apply text-[20px] font-medium leading-[28.96px] tracking-[1px];
  @apply tablet:(mt-[26px]);
}

.solgan {
  @apply mt-[52px] text-[24px] relative underline underline-secondary-100 underline-offset-0px tracking-[1px] leading-[1.2];
  @apply tablet:(text-[40px] leading-[57.92px] underline-offset-5px);
}
.sub-solgan {
  @apply font-bold text-[26px] leading-[37.65px] tracking-[1px] mt-[24px];
  @apply tablet:(text-[36px] leading-[52.13px] mt-[32px]);
}
/* .solgan::before {
  content: '';
  @apply absolute  bottom-[0px] w-full h-[3px] bg-secondary-100;
} */

.item {
  @apply select-none;
}

:deep(.carousel__prev) {
  @apply bg-[#c2bcdf] w-[41.91px] h-[41.91px] left-[30px];
}
:deep(.carousel__next) {
  @apply bg-[#c2bcdf] w-[41.91px] h-[41.91px] right-[30px];
}

:deep(.carousel__pagination) {
  @apply relative bottom-[-24px];
  /* @apply mt-[44px]; */
}

:deep(.carousel__pagination-item button) {
  @apply h-[10px] bg-[#c9c9c9];
}

:deep(.carousel__pagination-button--active) {
  @apply !bg-primary-100;
}
</style>
